import { parseJSON } from 'date-fns';
import { format } from 'date-fns-tz';
import { GridCustomCellProps } from '@progress/kendo-react-grid';

const DateTimeCell = (props: GridCustomCellProps) => {
  if (!props.field || props.rowType !== 'data') return null;
  if (!props.dataItem[props.field]) return <td {...props.tdProps} />;

  return <td {...props.tdProps}>{format(props.dataItem[props.field] instanceof Date ? props.dataItem[props.field] : parseJSON(props.dataItem[props.field]), 'LL/dd/yyyy HH:mm zzz')}</td>
}

export default DateTimeCell;
